import { useEffect, useState } from "react";
import {
  Dropdown,
  Menu,
} from "antd";
import InitiateExternal from "./modals/initiateExternalPayment";
import InitiateInternal from "./modals/initiateInternalPayment";
import { ArrowRightOutlined } from "@ant-design/icons";
import PermissionGate from '../../../helpers/PermissionGate'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

const InitiateSinglePaymentDropdown = ({ bankAccountInfo, bankAccountId, bankAccountSource, updateExternalTransactions, updateInternalTransactions, updatePaymentRequests }) => {
  const [hasExternal, setHasExternal] = useState(false);
  const [hasInternal, setHasInternal] = useState(false);
  const [hasNeither, setHasNeither] = useState(false);
  const [accountStatus, setAccountStatus] = useState(false);

  useEffect(() => {
    if (bankAccountInfo) {
      const external = bankAccountInfo.has_ach || bankAccountInfo.has_wire;
      const internal = bankAccountInfo.has_book_transfer;

      setHasExternal(external);
      setHasInternal(internal);
      setAccountStatus(bankAccountInfo.status);
      setHasNeither(!external && !internal);
    }
  }, [bankAccountInfo]);

  const menu = (
    <Menu>
      {hasExternal && (
        <Menu.Item key="external">
          <InitiateExternal
            params={"modal"}
            amount=""
            recipientId=""
            bankAccountId={bankAccountId}
            updateTransactions={updateExternalTransactions}
            availableBalance={bankAccountInfo.available_balance_raw}
            bankAccountSource={bankAccountSource}
            updatePaymentRequests={updatePaymentRequests}
          />
        </Menu.Item>
      )}
      {hasInternal && (
        <Menu.Item key="internal">
          <InitiateInternal
            bankAccountId={bankAccountId}
            bankAccountSource={bankAccountSource}
            updateTransactions={updateInternalTransactions}
            availableBalance={bankAccountInfo.available_balance_raw}
            updatePaymentRequests={updatePaymentRequests}
          />
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <>
      {bankAccountInfo && !hasNeither && accountStatus !== 'Closed' ? (
        <PermissionGate
          requiredLimit='create'
          readOnly={
            <Typography>
              Send Funds <ArrowRightOutlined />
            </Typography>
          }
          spanSettings={{
            style: { cursor: 'not-allowed', fontWeight: '600', fontSize: '14px', color: 'rgba(0,0,0,0.25)' },
          }}
          toolTipPlacement='top'
          toolTipText='Send funds not permitted. Please check permission with your admin.'
        >
          <Dropdown overlay={menu} placement='bottomLeft' arrow>
            <span style={{ fontWeight: '400', fontSize: '14px', color: '#1890ff', cursor: 'pointer' }}>
              Send Funds <ArrowRightOutlined />
            </span>
          </Dropdown>
        </PermissionGate>
      ) : (
        <Tooltip arrow title={<Typography>Send funds not enabled.</Typography>}>
          <span
            style={{
              fontWeight: '600',
              fontSize: '14px',
              color: 'rgba(0,0,0,0.25)',
              cursor: 'not-allowed',
            }}
          >
            Send Funds <ArrowRightOutlined />
          </span>
        </Tooltip>
      )}
    </>
  )
};

export default InitiateSinglePaymentDropdown;
